import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import BasicDetails from "./BasicDetails";
import PurchaseDetails from "./PurchaseDetails";
import SupportingDocument from "./SupportingDocument";

const BaseForm = ({
    setIsAddAssetModal,
    addAssetFunctionMutate,
    isaddAssetLoading,
    setFormData, formData, vendorList, expenseData, setIsAddVendor, selectedData,
    setShowAddVendorForm,
    showAddVendorForm,
    addVendorMutate,
    addVendorLoading,
    setVendorMobile,
    vendorMobile,
    vendorName,
    setVendorName,
    handleMaintenanceClose,
    handleVendorFormClose
}) => {
    const [selectedForm, setSelectedForm] = useState(selectedData || null);
    const [height, setHeight] = useState(window.innerHeight);

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight); // updates when Safari UI changes
        };
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);
    const onClose = () => {
        setIsAddAssetModal(false);
        setSelectedForm("1");
        setVendorMobile("");
        setVendorName("");
    };

    const renderContent = () => {
        switch (selectedForm) {
            case "2":
                return (
                    <PurchaseDetails
                        setIsAddAssetModal={setIsAddAssetModal}
                        setSelectedForm={setSelectedForm}
                        setFormData={setFormData}
                        vendorList={vendorList}
                        expenseData={expenseData}
                        setIsAddVendor={setIsAddVendor}
                        showAddVendorForm={showAddVendorForm}
                        setShowAddVendorForm={setShowAddVendorForm}
                        addVendorMutate={addVendorMutate}
                        addVendorLoading={addVendorLoading}
                        vendorName={vendorName}
                        setVendorName={setVendorName}
                        vendorMobile={vendorMobile}
                        setVendorMobile={setVendorMobile}
                        handleMaintenanceClose={handleMaintenanceClose}
                        handleVendorFormClose={handleVendorFormClose}
                    />
                );

            case "3":
                return (
                    <SupportingDocument
                        setIsAddAssetModal={setIsAddAssetModal}
                        setSelectedForm={setSelectedForm}
                        setFormData={setFormData}
                        formData={formData}
                        addAssetFunctionMutate={addAssetFunctionMutate}
                        isaddAssetLoading={isaddAssetLoading}
                    />
                );
            default:
                return (
                    <BasicDetails
                        setIsAddAssetModal={setIsAddAssetModal}
                        setSelectedForm={setSelectedForm}
                        onClose={onClose}
                        setFormData={setFormData}
                    />
                );
        }
    };

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <Title>{"Add Assets"}</Title>
                <CloseButton onClick={onClose}>
                    <MdClose size={24} />
                </CloseButton>
            </Header>
            <Content>{renderContent()}</Content>
        </Container>
    );
};

const Container = tw.div`bg-white w-full h-full flex flex-col`;
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;
const Title = tw.h1`text-white text-lg md:text-xl font-medium`;
const CloseButton = tw.button`text-white`;
const Content = tw.div`px-6 h-full flex flex-col justify-between relative`;

export default BaseForm;
